import { render, staticRenderFns } from "./IdentityManager.vue?vue&type=template&id=1bd25a42&scoped=true";
import script from "./IdentityManager.vue?vue&type=script&lang=js";
export * from "./IdentityManager.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "1bd25a42", null);
export default component.exports;